import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Mail, Loader2 } from "lucide-react";

import { _t } from "@/lib/i18n";
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0b0d] px-4">
      <div className="tc-card p-8 md:p-10 w-full max-w-md">
        <div className="mb-6 flex items-center gap-3">
          <Mail className="w-6 h-6 text-[#FF5722]" />
          <h1 className="font-display text-2xl text-white">{_t("Password dimenticata?")}</h1>
        </div>
        {sent ? (
          <div data-testid="forgot-sent" className="text-white/80">
            <p>{_t("Se l'indirizzo è associato a un account, riceverai una email con le istruzioni per reimpostare la password.")}</p>
            <p className="text-white/50 mt-3 text-sm">{_t("Controlla anche la cartella Spam. Il link è valido per 45 minuti.")}</p>
            <Link to="/login" className="btn-primary mt-6 inline-flex">{_t("Torna al login")}</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <label className="block text-sm text-white/70">{_t("Email dell'account")}</label>
            <input data-testid="forgot-email-input" type="email" required
                   value={email} onChange={(e) => setEmail(e.target.value)}
                   className="input-base w-full" placeholder="tu@esempio.it" />
            <button data-testid="forgot-submit" type="submit" disabled={busy} className="btn-primary w-full">
              {busy ? <><Loader2 className="w-4 h-4 animate-spin" />{" "}{_t("Invio…")}</> : _t("Invia link di reset")}
            </button>
            <Link to="/login" className="block text-sm text-white/50 text-center hover:text-white">{_t("Ricordo la password")}</Link>
          </form>
        )}
      </div>
    </div>
  );
}
